var exports = {
  "kL": "xcc377c0b--612380--container",
  "Sl": "xcc377c0b--612380--image",
  "DD": "xcc377c0b--612380--title",
  "Qs": "xcc377c0b--612380--content",
};

module.exports = exports;
